import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { Component } from "react";
import ClientPageHeader from "./ClientPageHeader";
import swal from "sweetalert";
import Paginations from "../GenericComponents/Pagination";
import TableEmptyRow, {
  visibleTableColumnCount,
} from "../GenericComponents/TableEmptyRow";
import EmployeeActivityBars from "../Settings/EmployeeActivityBars";
import Loader from "../Loader/Loader";
import {
  delete_ApiManager,
  get_ApiManager,
  post_ApiManager,
  search_ApiManager,
  view_ApiManager,
} from "../ApiManager/ApiManager";
import ExportOptions from "../GenericComponents/ExportOptions";
import moment from "moment";
import { Link } from "react-router-dom";
import "./clients.css";
import {
  expandMultiFilterChips,
  removeFromMultiFilterState,
  scalarFilterChip,
} from "../../utilis/filterChipLabels";
import ActiveFilterChips from "../GenericComponents/ActiveFilterChips";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Sorting } from "../GenericComponents/SortTables";
import GenericMerge from "../GenericComponents/GenericMerge";
import {
  activate_status,
  expo_branches,
  genders,
  info_message,
} from "../../utilis/constants";
import MultipleSearchs from "../GenericComponents/MultipleSearchs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExternalAgentModel from "../GenericComponents/ExternalAgentModel";
import {
  FaChevronDown,
  FaChevronUp,
  FaEye,
  FaSlidersH,
  FaTrashAlt,
} from "react-icons/fa";
import { getDeactivatedUsers } from "../Services/apiServices";

class ViewClients extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.scrollRef = React.createRef();
    var permissions = getPermissions();
    var userDetail = JSON.parse(localStorage.getItem("user"));
    this.state = {
      merged_client: [],
      name: "",
      email: "",
      phone: "",
      country: "",
      counselor: [],
      superAgent: [],
      subAgent: [],
      gender: "",
      assignedTo: [],
      branch: "",
      event: "",
      getStartDate: "",
      sDate: null,
      eDate: null,
      signupStartDate: null,
      signupEndDate: null,
      getEndDate: "",
      allUsers: [],
      participants: [],
      totalItem: "",
      clientName: "",
      currentPage: 1,
      assignedID: "",
      lastPage: "",
      perPage: 10,
      open: false,
      search: "",
      days: null,
      allClients: [],
      order: "ASC",
      userRole: userDetail,
      perItem: "",
      allAgents: [],
      selectedClients: [],
      allPermissions: permissions,
      bulk: false,
      bulkIds: [],
      events: [],
      status: 2,
      deactivated: [],
      duplicate: false,
      showMerge: false,
      infoMessage: "",
      deactivatedUsers: [],
      externalAgentModel: false,
      rExternalList: [],
      pExternalList: [],
      externalRAgentType: "",
      externalPAgentType: "",
      showMoreFilters: false,
      headers: [
        {
          title: "#",
          dataKey: "index",
          align: "text-center",
          key: 1,
          checked: true,
          canChange: false,
        },
        {
          title: "Created By",
          dataKey: "counselor",
          align: "text-center",
          key: 2,
          checked: true,
          canChange: false,
        },
        {
          title: "Client",
          dataKey: "name",
          align: "w-10",
          key: 3,
          checked: true,
          canChange: false,
        },
        {
          title: "Email",
          dataKey: "email",
          align: "text-center ",
          key: 4,
          checked: true,
          canChange: false,
        },
        {
          title: "Phone",
          dataKey: "mobile",
          align: "text-center ",
          key: 5,
          checked: true,
          canChange: true,
        },
        {
          title: "Country",
          dataKey: "country",
          align: "text-center ",
          key: 6,
          checked: false,
          canChange: true,
        },
        {
          title: "Gender",
          dataKey: "gender",
          align: "text-center ",
          key: 7,
          checked: false,
          canChange: true,
        },
        {
          title: "Processing Branch",
          dataKey: "superagent",
          align: "text-center ",
          key: 8,
          checked: true,
          canChange: true,
        },
        {
          title: "Referring Branch",
          dataKey: "subagent",
          align: "text-center ",
          key: 9,
          checked: true,
          canChange: true,
        },
        {
          title: "AssignedTo",
          dataKey: "assignedTo",
          align: "text-center",
          key: 10,
          checked: true,
          canChange: true,
        },
        {
          title: "CreatedAt",
          dataKey: "created_at",
          align: "text-center",
          key: 11,
          checked: false,
          canChange: true,
        },
        {
          title: "Event",
          dataKey: "event",
          align: "text-center",
          key: 12,
          checked: false,
          canChange: true,
        },
        {
          title: "Branch",
          dataKey: "branch",
          align: "text-center",
          key: 13,
          checked: false,
          canChange: true,
        },
        {
          title: "Active Status",
          dataKey: "active_status",
          align: "text-center",
          key: 14,
          checked: false,
          canChange: true,
        },
        {
          title: "Reference By",
          dataKey: "referred_by",
          align: "text-center",
          key: 15,
          checked: false,
          canChange: true,
        },
        {
          title: "",
          dataKey: "",
          align: "text-center",
          key: 16,
          checked: false,
          canChange: true,
        },
        {
          title: "Signup Date",
          dataKey: "signup_date",
          align: "text-center",
          key: 18,
          checked: true,
          canChange: true,
        },
        {
          title: "Actions",
          align: "text-center",
          dataKey: "",
          key: 17,
          checked: true,
          canChange: false,
        },
      ],
    };
    this.handleSearchCallback = this.handleSearchCallback.bind(this);
    this.triggerClientSearch = null;
    this.resetClientFilters = null;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.allPermissions["clients"] === 1) {
      this.getClients();
      this.getAgents();
      this.getEvents();
      this.getAllUsers();
      this.getDeactivatedUsers();
    }
  }
  getDeactivatedUsers = async () => {
    let result = await getDeactivatedUsers();
    console.log("deactivated", result);
    if (result.error) {
      swal({ text: result.error, icon: "warning", dangerMode: true });
    } else {
      this.setState({ deactivated: result.data.data });
    }
  };
  getAllUsers = () => {
    let url = "getAllUsers";
    view_ApiManager(
      url,
      0,
      0,
      (res) => {
        console.log("Get all Users", res);
        const participants = res.data.data.map((user) => ({
          label: user.name, // Adjust the property name based on your API response
          value: user.id,
        }));
        this.setState({ allUsers: res.data.data, participants: participants });
      },
      (err) => {
        console.log(err);
      },
    );
  };
  getClients = () => {
    this.setState({ loading: true });
    let currentPage = this.state.currentPage;
    let perPage = this.state.perPage;
    let $startDate = this.state.sDate;
    let $endDate = this.state.eDate;
    let $days = this.state.days;
    let $signupStart = this.state.signupStartDate || "null";
    let $signupEnd = this.state.signupEndDate || "null";
    let url = `getAllClients/${$days}/${$startDate}/${$endDate}/${null}/${
      this.state.status
    }/${$signupStart}/${$signupEnd}`;
    console.log(url);
    view_ApiManager(
      url,
      currentPage,
      perPage,
      (res) => {
        console.log("All Clients", res);
        this.setState({
          allClients: res.data.data["data"],
          loading: false,
          totalItem: res.data.data["total"],
          perPage: res.data.data["per_page"],
          lastPage: res.data.data["last_page"],
          perItem: res.data.data["data"].length,
        });
        let options = res.data.data["data"].map(function (item) {
          return {
            index: item.index,
            counselor: item.counselor,
            name: item.name,
            email: item.email,
            mobile: item.mobile,
            country: item.country,
            gender: item.gender,
            superagent: item.superagent,
            subagent: item.subagent,
            assignedTo: item.assignedTo,
            created_at: moment(item.created_at).format("YYYY-MM-D"),
            referenceBy: item.referred_by,
          };
        });
        this.setState({ selectedClients: options });
      },
      (err) => {
        console.log(err);
      },
    );
  };
  // Assign application to user
  async AssignApp(clientID) {
    swal({
      title: "Are you sure?",
      text:
        "You want to assign this application to (" +
        this.state.clientName +
        ")",
      icon: "warning",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        let url = "assignedClient";
        const data = {
          clientId: clientID,
          assignedId: this.state.assignedID,
        };
        post_ApiManager(
          data,
          url,
          (res) => {
            console.log("Client Assigned", res);
            this.setState({ loading: false });
            if (res.data.error) swal(" ", res.data.error, "error");
            else {
              swal("Success!", res.data.message, "success");
              this.getClients();
            }
          },
          (err) => {
            console.log(err);
          },
        );
      }
    });
  }
  //CallBack function to get changed status name and value and call api to save results
  handleCallback = (days, startDate, endDate, status) => {
    console.log(days);
    let Status = this.state.status;
    if (status == "Active") {
      Status = 1;
    } else if (status == "Inactive") {
      Status = 0;
    } else if (status == "All") {
      Status = 2;
    }
    this.setState(
      { days: days, sDate: startDate, eDate: endDate, status: Status },
      () => {
        if (this.state.search) {
          this.handleSearchCallback("clear");
          this.setState({ infoMessage: info_message });
        }
        this.getClients();
      },
    );
  };
  // CallBack function handle pagination
  handlePaginationCallback = (i, perPage) => {
    window.scrollTo(0, this.scrollRef);
    if (this.state.search == "") {
      if (perPage && perPage != "") {
        this.setState({ perPage: perPage, currentPage: 1 }, () => {
          this.getClients();
        });
      } else {
        this.setState({ currentPage: i }, () => {
          this.getClients();
        });
      }
    } else {
      if (perPage && perPage != "") {
        this.setState({ perPage: perPage, currentPage: 1 }, () => {
          this.handleSearchCallback("yes");
        });
      } else {
        this.setState({ currentPage: i }, () => {
          this.handleSearchCallback("yes");
        });
      }
    }
  };

  handleChange(event, clientID) {
    this.setState(
      {
        assignedID: event.target.value,
        clientName: event.target.options[event.target.selectedIndex].text,
      },
      () => {
        this.AssignApp(clientID);
      },
    );
  }
  // Table sorting
  sorting = (col) => {
    const sortResult = Sorting(this.state.allClients, col, this.state.order);
    this.setState({ order: sortResult[0], allClients: sortResult[1] });
  };
  handleSearchCallback = (
    input1,
    input2,
    input3,
    input4,
    input5,
    input6,
    input7,
    input8,
    input9,
    input10,
    input11,
    input12,
  ) => {
    if (input1 !== "clear") {
      const { signupStartDate, signupEndDate } = this.state;
      if (
        signupStartDate &&
        signupEndDate &&
        signupEndDate < signupStartDate
      ) {
        swal(
          "Invalid dates",
          "Signup end date cannot be before start date.",
          "warning",
        );
        return;
      }
    }

    let Name,
      Email,
      Phone,
      Country,
      Counselor,
      SuperAgent,
      SubAgent,
      Gender,
      Assigned,
      Branch,
      Event,
      DeactivatedUsers;
    if (input1 === "clear") {
      this.setState(
        {
          name: "",
          email: "",
          phone: "",
          mobile: "",
          gender: "",
          country: "",
          counselor: [],
          assignedTo: [],
          superAgent: [],
          subAgent: [],
          sDate: null,
          eDate: null,
          days: null,
          signupStartDate: null,
          signupEndDate: null,
          branch: "",
          event: "",
          deactivatedUsers: "",
          search: "",
          currentPage: 1,
        },
        () => this.getClients(),
      );
      return;
    } else if (input1 === "yes") {
      Name = this.state.name;
      Email = this.state.email;
      Phone = this.state.phone;
      Country = this.state.country;
      Counselor = this.state.counselor;
      SuperAgent = this.state.superAgent;
      SubAgent = this.state.subAgent;
      Gender = this.state.gender;
      Assigned = this.state.assignedTo;
      Branch = this.state.branch;
      Event = this.state.event;
      DeactivatedUsers = this.state.deactivatedUsers;
    } else {
      Name = input1;
      Email = input2;
      Phone = input3;
      Country = input4;
      Gender = input5;
      SuperAgent = input6;
      SubAgent = input7;
      Assigned = input8;
      Counselor = input9;
      Event = input10;
      Branch = input11;
      DeactivatedUsers = input12;
      this.setState({
        search: "yes",
        currentPage: 1,
        name: Name,
        email: Email,
        phone: Phone,
        gender: Gender,
        counselor: Counselor,
        superAgent: SuperAgent,
        subAgent: SubAgent,
        branch: Branch,
        assignedTo: Assigned,
        branch: Branch,
        event: Event,
        deactivatedUsers: DeactivatedUsers,
      });
    }
    const pageForRequest = input1 === "yes" ? this.state.currentPage : 1;
    const data = {
      name: Name,
      email: Email,
      phone: Phone,
      country: Country,
      counselor: Counselor,
      superagent: SuperAgent,
      assignedTo: Assigned,
      subagent: SubAgent,
      sDate: this.state.sDate ? this.state.sDate : "null",
      eDate: this.state.eDate ? this.state.eDate : "null",
      days: this.state.days ? this.state.days : "null",
      activeStatus: this.state.status,
      status: this.state.headers[10]["checked"],
      branch: Branch,
      event: Event,
      gender: this.state.headers[6]["checked"]
        ? Gender == 1
          ? "Female"
          : "Male"
        : "",
      deactivated: DeactivatedUsers,
      signup_start_date: this.state.signupStartDate || "null",
      signup_end_date: this.state.signupEndDate || "null",
    };
    let perPage = this.state.perPage;
    let url = `search/clients`;
    console.log(data);
    search_ApiManager(
      url,
      data,
      pageForRequest,
      perPage,
      (res) => {
        console.log("search result", res);
        this.setState({
          allClients: res.data.data["data"],
          totalItem: res.data.data["total"],
          perPage: res.data.data["per_page"],
          lastPage: res.data.data["last_page"],
          perItem: res.data.data["data"].length,
          currentPage: res.data.data["current_page"] || pageForRequest,
        });
        let options = res.data.data["data"].map(function (item) {
          return {
            index: item.index,
            counselor: item.counselor,
            name: item.name,
            email: item.email,
            mobile: item.mobile,
            country: item.country,
            gender: item.gender,
            superagent: item.superagent,
            subagent: item.subagent,
            assignedTo: item.assignedTo,
            created_at: moment(item.created_at).format("YYYY-MM-D"),
            referenceBy: item.referred_by,
          };
        });
        this.setState({ selectedClients: options });
      },
      (err) => {
        console.log(err);
      },
    );
  };
  //Delete a user
  async deleteClient(delete_id, name) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover (" + name + ")",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let url = "clients";
        delete_ApiManager(
          delete_id,
          url,
          (res) => {
            console.log("User Deleted", res);
            if (res.data.error) swal(" ", res.data.error, "error");
            else {
              swal("Client (" + name + ")" + " deleted successfully", {
                icon: "success",
              });
              this.setState({ loading: false, currentPage: 1 });
              this.getClients();
            }
          },
          (err) => {
            console.log(err);
          },
        );
      }
    });
  }

  handleColumnsCallback = (selectedColumns) => {
    this.setState({ headers: selectedColumns });
  };

  handleSignupDateFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "signupStartDate" && !value) {
      this.setState({ signupStartDate: null, signupEndDate: null });
      return;
    }
    this.setState({ [name]: value || null });
  };

  getSignupDateDisplay = (client) => {
    const isSignedUp =
      client?.is_signup == 1 ||
      client?.is_signup === "1" ||
      client?.is_signup === true;

    if (!isSignedUp) return "";

    const dateVal = client?.signup_date || client?.signup_at;
    if (!dateVal) return "";

    const formatted = moment(dateVal);
    return formatted.isValid() ? formatted.format("D MMMM YYYY") : "";
  };
  async showDuplicateClients() {
    let url = "getDuplicateClients";
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("duplicate-clients", res);
        this.setState({
          allClients: res.data.data,
          perItem: res.data.data.length,
          totalItem: res.data.data.length,
          perPage: res.data.data.length,
        });
      },
      (err) => {
        console.log(err);
      },
    );
  }

  async getAgents() {
    let url = "getAgentsByOffice";
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("agents", res);
        this.setState({ allAgents: res.data.data });
      },
      (err) => {
        console.log(err);
      },
    );
  }
  onBulkClick = (id, name, checked, value) => {
    console.log(id, checked);
    if (checked == true) {
      const newState = this.state.allClients.map((obj) => {
        if (obj.id == id) {
          return { ...obj, checked: true };
        }
        return obj;
      });
      // this.setState({
      //   bulkIds: [...this.state.bulkIds, { id: id, name: name }],
      //   merged_client: [...this.state.merged_client, value],
      //   allClients: newState,
      //   bulk: true,
      // });
      this.setState((prevState) => ({
        bulkIds: [...prevState.bulkIds, { id: id, name: name }],
        merged_client: [...prevState.merged_client, value],
        allClients: newState,
        bulk: true,
      }));
    } else {
      const newState = this.state.allClients.map((obj) => {
        if (obj.id == id) {
          return { ...obj, checked: false };
        }
        return obj;
      });
      // var array = this.state.bulkIds.filter(function (item) {
      //   return item.id !== id;
      // });
      // this.setState({ bulkIds: array, allClients: newState });
      this.setState((prevState) => {
        const bulkIds = prevState.bulkIds.filter((item) => item.id !== id);
        const merged_client = prevState.merged_client.filter(
          (client) => client.id !== id,
        );
        return {
          bulkIds,
          merged_client,
          allClients: newState,
          bulk: bulkIds.length > 0,
        };
      });
    }
  };

  clearBulkSelection = () => {
    const newState = this.state.allClients.map((obj) => ({
      ...obj,
      checked: false,
    }));
    this.setState({
      bulk: false,
      bulkIds: [],
      allClients: newState,
      merged_client: [],
    });
  };

  handleSelectAllChange = (checked) => {
    if (checked) {
      this.allBulk();
    } else {
      this.clearBulkSelection();
    }
  };

  truncateWords = (text, maxWords = 3) => {
    const words = String(text).trim().split(/\s+/).filter(Boolean);
    if (words.length <= maxWords) {
      return { display: String(text), full: String(text) };
    }
    return {
      display: `${words.slice(0, maxWords).join(" ")}...`,
      full: String(text),
    };
  };

  renderTruncatedCell = (content) => {
    const text =
      content === null || content === undefined || content === ""
        ? "--"
        : String(content);
    if (text === "--") {
      return (
        <span className="block max-w-full truncate text-xs font-medium text-slate-400">
          --
        </span>
      );
    }
    const { display, full } = this.truncateWords(text, 3);
    return (
      <span
        className="block max-w-full truncate text-xs font-semibold text-slate-800"
        title={full}
      >
        {display}
      </span>
    );
  };

  onBulkAssigned = (assignedId) => {
    let url = "assignedBulkClients";
    const data = {
      bulkList: this.state.bulkIds,
      assignedId: assignedId,
    };
    console.log(data);
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("Clients Assigned", res);
        this.setState({ loading: false });
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Success!", res.data.message, "success");
          this.getClients();
          this.setState({ bulk: false, bulkIds: [] });
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };
  onBulkDelete = () => {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover these clients",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let url = "assignedBulkDelete";
        const data = {
          bulkList: this.state.bulkIds,
        };
        console.log(data);
        post_ApiManager(
          data,
          url,
          (res) => {
            console.log("clients-deleted", res);
            if (res.data.error) swal(" ", res.data.error, "error");
            else {
              swal("Clients deleted successfully", { icon: "success" });
              this.getClients();
              this.setState({ bulk: false, bulkIds: [] });
            }
          },
          (err) => {
            console.log(err);
          },
        );
      }
    });
  };
  onMergeClick = () => {
    this.setState({ showMerge: true });
  };
  // All Bulk
  allBulk = () => {
    const newState = this.state.allClients.map((obj) => {
      return { ...obj, checked: true };
    });
    const array = [];
    this.state.allClients.map((x) => {
      array.push({ id: x.id });
    });
    this.setState({ allClients: newState, bulk: true, bulkIds: array });
    const mergedArray = this.state.allClients.map((client) => client);
    this.setState({
      merged_client: mergedArray,
    });
  };
  // Select Bulk
  selectBulk = () => {
    const newState = this.state.allClients.map((obj) => {
      return { ...obj, checked: false };
    });
    this.setState({
      bulk: !this.state.bulk,
      bulkIds: [],
      allClients: newState,
      merged_client: [],
    });
  };
  async getEvents() {
    let url = "getEvents";
    view_ApiManager(
      url,
      this.state.currentPage,
      this.state.perPage,
      (res) => {
        console.log("expo-list", res);
        this.setState({ events: res.data.data["data"] });
      },
      (err) => {
        console.log(err);
      },
    );
  }

  handleMergeModelCallback = async (check, type, mergeTo, list) => {
    if (type == "edit") {
      let url = "mergeClients";
      const data = {
        mergeTo: mergeTo,
        list: list,
      };
      console.log(data);
      post_ApiManager(
        data,
        url,
        (res) => {
          console.log("merge-clients", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            swal(" ", res.data.message, "success");
            this.setState({ showMerge: false, bulkIds: [], merged_client: [] });
            this.getClients();
          }
        },
        (err) => {
          console.log(err);
        },
      );
    } else {
      this.setState({ showMerge: false });
    }
  };

  onBulkActiveStatus = (status) => {
    let url = "bulkClientStatus";
    const data = {
      bulkList: this.state.bulkIds,
      status: status,
    };
    console.log(data);
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("Clients Assigned", res);
        this.setState({ loading: false });
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Success!", res.data.message, "success");
          this.getClients();
          this.setState({ bulk: false, bulkIds: [] });
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };
  handleExternalAgentCallback = () => {
    this.setState({ externalAgentModel: false, bulkIds: [], bulk: false });
    if (!this.state.search) {
      this.getClients();
    } else {
      this.handleSearchCallback(this.state.search);
    }
  };
  handleBranchCallback = (branch) => {
    this.setState({ selectedBranch: branch }, () => {
      this.getClients();
    });
  };

  getStatusLabel = () => {
    if (this.state.status === 1) return "Active";
    if (this.state.status === 0) return "Inactive";
    return "All";
  };

  getActiveFilterChips = () => {
    const chips = [];
    const {
      name,
      email,
      phone,
      country,
      branch,
      event,
      days,
      sDate,
      eDate,
      signupStartDate,
      signupEndDate,
      counselor,
      superAgent,
      subAgent,
      assignedTo,
      gender,
      deactivatedUsers,
    } = this.state;

    if (name) chips.push(scalarFilterChip("name", `Client: ${name}`));
    if (email) chips.push(scalarFilterChip("email", `Email: ${email}`));
    if (phone) chips.push(scalarFilterChip("phone", `Phone: ${phone}`));
    if (country) chips.push(scalarFilterChip("country", `Country: ${country}`));
    if (branch) chips.push(scalarFilterChip("branch", `Branch: ${branch}`));
    if (event) chips.push(scalarFilterChip("event", `Event: ${event}`));
    if (days) chips.push(scalarFilterChip("days", `Days: ${days}`));
    if (sDate) chips.push(scalarFilterChip("sDate", `From: ${sDate}`));
    if (eDate) chips.push(scalarFilterChip("eDate", `To: ${eDate}`));
    if (signupStartDate) {
      chips.push(scalarFilterChip("signupStartDate", `Signup from: ${signupStartDate}`));
    }
    if (signupEndDate) {
      chips.push(scalarFilterChip("signupEndDate", `Signup to: ${signupEndDate}`));
    }
    if (this.state.status !== 2) {
      chips.push(scalarFilterChip("status", `Status: ${this.getStatusLabel()}`));
    }
    if (gender) chips.push(scalarFilterChip("gender", `Gender: ${gender}`));
    chips.push(...expandMultiFilterChips("counselor", "Created by", counselor, "name"));
    chips.push(
      ...expandMultiFilterChips("superAgent", "Processing", superAgent, "agencyname"),
    );
    chips.push(...expandMultiFilterChips("subAgent", "Referring", subAgent, "agencyname"));
    chips.push(...expandMultiFilterChips("assignedTo", "Assigned", assignedTo, "name"));
    chips.push(
      ...expandMultiFilterChips(
        "deactivatedUsers",
        "Deactivated users",
        deactivatedUsers,
        "name",
      ),
    );
    return chips;
  };

  refreshAfterFilterChange = () => {
    if (this.state.search) {
      this.handleSearchCallback("yes");
    } else {
      this.getClients();
    }
  };

  removeFilterChip = (chip) => {
    const key = chip?.key ?? chip;
    const itemKey = chip?.itemKey;

    if (itemKey != null) {
      const multiKeys = {
        counselor: { stateKey: "counselor", displayKey: "name" },
        superAgent: { stateKey: "superAgent", displayKey: "agencyname" },
        subAgent: { stateKey: "subAgent", displayKey: "agencyname" },
        assignedTo: { stateKey: "assignedTo", displayKey: "name" },
        deactivatedUsers: { stateKey: "deactivatedUsers", displayKey: "name" },
      };
      const config = multiKeys[key];
      if (config) {
        const current = this.state[config.stateKey];
        const next = removeFromMultiFilterState(current, itemKey, config.displayKey);
        this.setState({ [config.stateKey]: next }, this.refreshAfterFilterChange);
        return;
      }
    }

    const resets = {
      name: { name: "" },
      email: { email: "" },
      phone: { phone: "" },
      country: { country: "" },
      branch: { branch: "" },
      event: { event: "" },
      days: { days: null },
      sDate: { sDate: null },
      eDate: { eDate: null },
      signupStartDate: { signupStartDate: null, signupEndDate: null },
      signupEndDate: { signupEndDate: null },
      status: { status: 2 },
      gender: { gender: "" },
      counselor: { counselor: [] },
      superAgent: { superAgent: [] },
      subAgent: { subAgent: [] },
      assignedTo: { assignedTo: [] },
      deactivatedUsers: { deactivatedUsers: [] },
    };

    this.setState(resets[key] || {}, this.refreshAfterFilterChange);
  };

  clearAllFilters = () => {
    this.resetClientFilters?.();
    this.handleSearchCallback("clear");
    this.setState({
      days: null,
      sDate: null,
      eDate: null,
      status: 2,
      signupStartDate: null,
      signupEndDate: null,
      search: "",
      infoMessage: "",
    });
  };

  renderRowActions = (value) => (
    <div className="inline-flex items-center justify-center gap-2">
      <Link
        to={`/clients/view-client-detail/${value.id}`}
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-blue-100 text-blue-700 shadow-sm no-underline transition hover:bg-blue-200 hover:text-blue-900"
        title="View client"
        aria-label={`View ${value.name}`}
      >
        <FaEye size={13} />
      </Link>
      {this.state.userRole["role"] === 2 && (
        <button
          type="button"
          onClick={() => this.deleteClient(value.id, value.name)}
          className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-red-100 text-red-700 shadow-sm transition hover:bg-red-200 hover:text-red-900"
          title="Delete client"
          aria-label={`Delete ${value.name}`}
        >
          <FaTrashAlt size={12} />
        </button>
      )}
    </div>
  );

  renderBulkActions = () => {
    if (!this.state.bulk || !this.state.bulkIds[0]) {
      return null;
    }

    const sortedUsers = []
      .concat(this.state.allUsers)
      .sort((a, b) => (a.name > b.name ? 1 : -1));

    return (
      <div
        className="flex flex-wrap items-center justify-end gap-1.5"
        role="toolbar"
        aria-label="Bulk client actions"
      >
        <select
          className="h-8 min-w-[132px] max-w-[150px] cursor-pointer appearance-none rounded-full border border-slate-300 bg-white bg-[length:10px] bg-[position:right_0.5rem_center] bg-no-repeat px-3 pr-7 text-[11px] font-bold text-slate-700 shadow-sm transition hover:border-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2210%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%2364748b%22%20d%3D%22M3%204.5L6%207.5L9%204.5%22/%3E%3C/svg%3E')]"
          name="assignedID"
          defaultValue="0"
          onChange={(e) => this.onBulkAssigned(e.target.value)}
          aria-label="Assign selected clients"
        >
          <option value="0">Assign Selected</option>
          <option value="0" disabled>
            Unassigned
          </option>
          {sortedUsers.map((value) => (
            <option key={value.id} className="light" value={value.id}>
              {value.name}
            </option>
          ))}
        </select>

        <select
          className="h-8 min-w-[132px] max-w-[150px] cursor-pointer appearance-none rounded-full border border-slate-300 bg-white bg-[length:10px] bg-[position:right_0.5rem_center] bg-no-repeat px-3 pr-7 text-[11px] font-bold text-slate-700 shadow-sm transition hover:border-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2210%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%2364748b%22%20d%3D%22M3%204.5L6%207.5L9%204.5%22/%3E%3C/svg%3E')]"
          name="statusID"
          defaultValue="0"
          onChange={(e) => this.onBulkActiveStatus(e.target.value)}
          aria-label="Change status for selected clients"
        >
          <option value="0" disabled>
            Select Status
          </option>
          {activate_status.map((value) => (
            <option key={value.title} className="light" value={value.title}>
              {value.title}
            </option>
          ))}
        </select>

        {this.state.userRole["role"] === 2 && (
          <button
            type="button"
            className="inline-flex h-8 items-center justify-center whitespace-nowrap rounded-full border border-red-300 bg-white px-3 text-[11px] font-bold text-red-700 shadow-sm transition hover:border-red-500 hover:bg-red-600 hover:text-black"
            onClick={() => this.onBulkDelete()}
          >
            Delete Selected
          </button>
        )}

        {this.state.bulkIds[1] && (
          <button
            type="button"
            className="inline-flex h-8 items-center justify-center whitespace-nowrap rounded-full border border-cyan-600 bg-cyan-600 px-3 text-[11px] font-bold text-white shadow-sm transition hover:border-cyan-700 hover:bg-cyan-700"
            onClick={() => this.onMergeClick()}
          >
            Merge Selected
          </button>
        )}

        {this.state.bulkIds[1] && (
          <button
            type="button"
            className="inline-flex h-8 items-center justify-center whitespace-nowrap rounded-full border border-emerald-300 bg-white px-3 text-[11px] font-bold text-emerald-700 shadow-sm transition hover:border-emerald-500 hover:bg-emerald-600 hover:text-black"
            onClick={() => this.setState({ externalAgentModel: true })}
          >
            Handle Agents
          </button>
        )}
      </div>
    );
  };

  renderMobileCards = (headers, count) => {
    if (!this.state.allClients.length) {
      return (
        <p className="py-8 text-center text-sm font-medium text-slate-500">
          No clients found
        </p>
      );
    }
    let rowCount = count;
    return this.state.allClients.map((value) => {
      rowCount++;
      return (
        <article key={value.id} className="rounded-xl border border-slate-200 bg-slate-50 p-3.5 shadow-sm">
          <div className="mb-2.5 flex items-start justify-between gap-2.5">
            <div className="flex min-w-0 flex-1 items-start gap-2.5">
              <input
                type="checkbox"
                className="m-0 mt-0.5 h-3.5 w-3.5 shrink-0 cursor-pointer accent-blue-600"
                checked={!!value.checked}
                onChange={(e) =>
                  this.onBulkClick(
                    value.id,
                    value.name,
                    e.target.checked,
                    value,
                  )
                }
                aria-label={`Select ${value.name}`}
              />
              <div className="min-w-0 flex-1">
                {headers[2]["checked"] && (
                  <Link
                    className="block text-xs font-bold text-blue-700 hover:text-blue-800 hover:underline"
                    to={`/clients/view-client-detail/${value.id}`}
                  >
                    {value.name}
                  </Link>
                )}
                {headers[1]["checked"] && (
                  <div className="mt-1 break-words text-xs font-semibold text-slate-800">
                    <small style={{ color: "#94a3b8" }}>
                      {value.userid === 0 ? "Manual Entry" : value.counselor}
                    </small>
                  </div>
                )}
              </div>
            </div>
            {headers[17]["checked"] && (
              <div className="flex shrink-0 items-center">
                {this.renderRowActions(value)}
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {headers[3]["checked"] && (
              <div className="col-span-full min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Email</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {value.email || "--"}
                </span>
              </div>
            )}
            {headers[4]["checked"] && (
              <div className="min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Phone</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {value.mobile || "--"}
                </span>
              </div>
            )}
            {headers[7]["checked"] && (
              <div className="min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Processing</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {value.superagent || "--"}
                </span>
              </div>
            )}
            {headers[8]["checked"] && (
              <div className="min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Referring</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {value.subagent || "--"}
                </span>
              </div>
            )}
            {headers[9]["checked"] && (
              <div className="min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Assigned To</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {value.assigned == 0 ? "Unassigned" : value.assignedTo}
                </span>
              </div>
            )}
            {headers[16]["checked"] && (
              <div className="min-w-0">
                <span className="mb-0.5 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Signup Date</span>
                <span className="break-words text-xs font-semibold text-slate-800">
                  {this.getSignupDateDisplay(value) || "--"}
                </span>
              </div>
            )}
          </div>
        </article>
      );
    });
  };

  render() {
    const role = JSON.parse(localStorage.getItem("user_role"));
    let count =
      this.state.currentPage * this.state.perPage - this.state.perPage + 1;
    const user = JSON.parse(localStorage.getItem("user_id"));
    const headers = this.state.headers;
    const showingFrom = this.state.totalItem > 0 ? count : 0;
    const showingTo =
      this.state.totalItem > 0
        ? Math.min(count + this.state.perItem - 1, this.state.totalItem)
        : 0;
    const activeChips = this.getActiveFilterChips();
    const selectedCount = this.state.bulkIds.length;
    const allRowsSelected =
      this.state.allClients.length > 0 &&
      this.state.allClients.every((client) => client.checked);
    const clientTableColSpan = visibleTableColumnCount(headers, 1);

    return (
      <div className="tailwind-container cms-list-page cms-view-clients-page">
        {this.state.allPermissions["clients"] === 1 ? (
          <>
            <ClientPageHeader
              totalItem={this.state.totalItem}
              onBranchChange={this.handleBranchCallback}
            />

            <div className="cms-primary-filters-bar mb-3">
              <div className="cms-filters-primary-grid cms-filters-primary-grid--three">
                <EmployeeActivityBars
                  days={this.state.days}
                  clients={true}
                  clientsPremium={true}
                  selectedsDate={this.state.sDate}
                  selectedeDate={this.state.eDate}
                  selectedStatus={this.getStatusLabel()}
                  parentCallback={this.handleCallback}
                />
              </div>
            </div>

            <div className="mb-4 overflow-visible rounded-xl border border-slate-200/90 bg-slate-50 p-4 shadow-sm cms-view-clients-filters">
              <div className="cms-filters-secondary-row flex flex-col items-stretch gap-2.5 overflow-visible">
                <div
                  className={`cms-filters-advanced-panel min-w-0 w-full overflow-visible ${
                    this.state.showMoreFilters ? "is-open" : "is-collapsed"
                  }`}
                >
                  <MultipleSearchs
                    premium
                    hideSearchButton
                    hideClearAll
                    hideTopToolbar
                    showColumnsAfterSearch
                    moreFiltersOpen={this.state.showMoreFilters}
                    searchRef={(fn) => {
                      this.triggerClientSearch = fn;
                    }}
                    columnsSettingsRef={(fn) => {
                      this.openColumnSettings = fn;
                    }}
                    clearFiltersRef={(fn) => {
                      this.resetClientFilters = fn;
                    }}
                    filterArraySync={{
                      input6: this.state.superAgent,
                      input7: this.state.subAgent,
                      input8: this.state.assignedTo,
                      input9: this.state.counselor,
                      input12: Array.isArray(this.state.deactivatedUsers)
                        ? this.state.deactivatedUsers
                        : this.state.deactivatedUsers
                          ? [this.state.deactivatedUsers]
                          : [],
                    }}
                    filterScalarSync={{
                      input1: this.state.name,
                      input2: this.state.email,
                      input3: this.state.phone,
                      input4: this.state.country,
                      input5: this.state.gender,
                      input10: this.state.event,
                      input11: this.state.branch,
                    }}
                    input1={headers[2]["checked"] && "Name or client/user ID"}
                  input1_type={"input"}
                  input2={headers[3]["checked"] && "Search Email"}
                  input2_type={"input"}
                  input3={headers[4]["checked"] && "Search Phone"}
                  input3_type={"input"}
                  input4={headers[5]["checked"] && "Search Country"}
                  input4_type={"input"}
                  input5={headers[6]["checked"] && "Search Gender"}
                  input5_type={"dropdown"}
                  input5Data={genders}
                  input5_multiple={"no"}
                  input6={headers[7]["checked"] ? "Search Processing" : ""}
                  input6_type={"dropdown"}
                  input6_multiple={"yes"}
                  input6Data={this.state.allAgents}
                  input6_filter_by={"agents"}
                  input7={headers[8]["checked"] && "Search Referring"}
                  input7_type={"dropdown"}
                  input7_multiple={"yes"}
                  input7Data={this.state.allAgents}
                  input7_filter_by={"agents"}
                  input8={headers[9]["checked"] && "AssignedTo"}
                  input8_type={"dropdown"}
                  input8Data={this.state.participants}
                  input8_multiple={"yes"}
                  input8_filter_by={"name"}
                  input8_suggestion={true}
                  input9={headers[1]["checked"] && "Created By"}
                  input9_type={"dropdown"}
                  input9Data={this.state.participants}
                  input9_multiple={"yes"}
                  input9_filter_by={"name"}
                  input9_suggestion={true}
                  showSignupDateFilter={headers[1]["checked"]}
                  signupStartDate={this.state.signupStartDate}
                  signupEndDate={this.state.signupEndDate}
                  onSignupDateChange={this.handleSignupDateFilterChange}
                  input10={headers[12]["checked"] && "Select Event"}
                  input10_type={"dropdown"}
                  input10Data={this.state.events}
                  input10_multiple={"no"}
                  input11={headers[13]["checked"] && "Select Branch"}
                  input11_type={"dropdown"}
                  input11Data={expo_branches}
                  input11_multiple={"no"}
                  input12={headers[15]["checked"] && "Deactivated Users"}
                  input12_type={"dropdown"}
                  input12Data={this.state.deactivated}
                  input12_filter_by={"name"}
                  input12_multiple={"yes"}
                  onSearchChange={this.handleSearchCallback}
                  onColumnsChange={this.handleColumnsCallback}
                  allColumns={headers}
                />
                </div>

                <button
                  type="button"
                  className={`cms-more-filters-btn inline-flex h-[38px] w-full shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border px-3.5 text-xs font-bold shadow-sm transition sm:w-auto ${
                    this.state.showMoreFilters ? "border-blue-400 bg-blue-50 text-blue-700" : "border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-100"
                  }`}
                  onClick={() =>
                    this.setState({ showMoreFilters: !this.state.showMoreFilters })
                  }
                  aria-expanded={this.state.showMoreFilters}
                >
                  <FaSlidersH size={11} />
                  <span>
                    {this.state.showMoreFilters ? "Less filters" : "More filters"}
                  </span>
                  {this.state.showMoreFilters ? (
                    <FaChevronUp size={10} />
                  ) : (
                    <FaChevronDown size={10} />
                  )}
                </button>
              </div>

              <ActiveFilterChips
                chips={activeChips}
                onRemove={this.removeFilterChip}
                onClearAll={activeChips.length > 0 ? this.clearAllFilters : undefined}
              />
            </div>

            {this.state.infoMessage && (
              <div className="mb-4 flex items-start gap-2.5 rounded-[10px] border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
                <FontAwesomeIcon icon={faInfoCircle} />
                <p className="mb-0">{this.state.infoMessage}</p>
              </div>
            )}

            {this.state.loading ? (
              <Loader />
            ) : (
              <div className="overflow-hidden rounded-xl border border-slate-200 border-t-4 border-t-blue-600 bg-white shadow-md" id="viewclientsdiv3" ref={this.scrollRef}>
                <div className="cms-table-toolbar">
                  <p className="cms-table-toolbar-text">
                    {this.state.totalItem > 0
                      ? `${Number(this.state.totalItem).toLocaleString()} clients · ${selectedCount} selected · Showing ${showingFrom}–${showingTo}`
                      : "\u00a0"}
                  </p>
                  <div className="cms-table-toolbar-actions">
                    {this.state.bulk && this.state.bulkIds[0] && (
                      <>
                        <div className="cms-table-toolbar-actions-group cms-table-toolbar-actions-group--contextual">
                          {this.renderBulkActions()}
                        </div>
                        <div
                          className="cms-table-toolbar-divider"
                          aria-hidden="true"
                        />
                      </>
                    )}
                    <div className="cms-table-toolbar-actions-group cms-table-toolbar-actions-group--static">
                      {(role === 2 || user === 18) && (
                        <div className="flex flex-wrap items-center gap-1.5">
                          <ExportOptions
                            pdffilename={"Clients.pdf"}
                            csvfilename={"Clients.csv"}
                            xlsxfilename={"Clients"}
                            header="Clients List"
                            id="viewclientsdiv3"
                            columns={headers}
                            data={this.state.selectedClients}
                            premium
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="cms-list-table-view min-h-40 overflow-x-auto bg-white">
                  <table id="viewclients" className="w-full min-w-[960px] border-collapse text-xs font-medium text-slate-800 [&_tbody_tr:nth-child(even)]:bg-slate-50/60 [&_tbody_tr:hover]:bg-blue-50/50 [&_tbody_tr:last-child_td]:border-b-0 [&_td]:border-b [&_td]:border-slate-200/80 [&_td]:px-3 [&_td]:py-3.5 [&_td]:align-middle [&_th]:cursor-pointer [&_th]:px-3 [&_th]:py-3 [&_th]:text-[11px] [&_th]:font-bold [&_th]:uppercase [&_th]:tracking-wide [&_th]:text-slate-600 [&_thead_tr]:border-b [&_thead_tr]:border-slate-200 [&_thead_tr]:bg-slate-100">
                    <thead>
                      <tr>
                        <th className="w-10 min-w-[40px] px-2 py-3 text-center !pl-3 !pr-2">
                          <input
                            type="checkbox"
                            className="m-0 h-4 w-4 cursor-pointer accent-blue-600"
                            checked={allRowsSelected}
                            onChange={(e) =>
                              this.handleSelectAllChange(e.target.checked)
                            }
                            aria-label="Select all clients"
                          />
                        </th>
                        {headers.map(
                          (head) =>
                            head.checked && (
                              <th
                                id={head.dataKey || undefined}
                                className={`${head.align}${
                                  head.key === 17
                                    ? " w-[96px] min-w-[96px] bg-slate-100 text-center"
                                    : ""
                                }`}
                                key={head.key}
                                onClick={() =>
                                  head.dataKey ? this.sorting(head.dataKey) : null
                                }
                              >
                                {head.title}
                              </th>
                            ),
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allClients.length === 0 ? (
                        <TableEmptyRow
                          colSpan={clientTableColSpan}
                          message="No clients found"
                        />
                      ) : (
                      this.state.allClients.map((value) => (
                        <tr key={value.id}>
                          <td className="w-10 min-w-[40px] px-2 py-3.5 text-center !pl-3 !pr-2">
                            <input
                              type="checkbox"
                              className="m-0 h-4 w-4 cursor-pointer accent-blue-600"
                              checked={!!value.checked}
                              onChange={(e) =>
                                this.onBulkClick(
                                  value.id,
                                  value.name,
                                  e.target.checked,
                                  value,
                                )
                              }
                              aria-label={`Select ${value.name}`}
                            />
                          </td>
                          {headers[0]["checked"] && (
                            <td className="text-center">{count++}</td>
                          )}
                          {headers[1]["checked"] && (
                            <td className="text-center name-text w-15 max-w-[160px]">
                              {this.renderTruncatedCell(
                                value.userid === 0
                                  ? "Manual Entry"
                                  : value.counselor,
                              )}
                            </td>
                          )}
                          {headers[2]["checked"] && (
                            <td className="max-w-[160px]">
                              <Link
                                className="block max-w-full truncate text-xs font-bold text-blue-700 hover:text-blue-800 hover:underline"
                                to={`/clients/view-client-detail/${value.id}`}
                                title={value.name}
                              >
                                {this.truncateWords(value.name, 3).display}
                              </Link>
                            </td>
                          )}
                          {headers[3]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.email)}
                            </td>
                          )}
                          {headers[4]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.mobile)}
                            </td>
                          )}
                          {headers[5]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.country)}
                            </td>
                          )}
                          {headers[6]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.gender)}
                            </td>
                          )}
                          {headers[7]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.superagent)}
                            </td>
                          )}
                          {headers[8]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.subagent)}
                            </td>
                          )}
                          {headers[9]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(
                                value.assigned == 0
                                  ? "Unassigned"
                                  : value.assignedTo,
                              )}
                            </td>
                          )}
                          {headers[10]["checked"] && (
                            <td className="text-center w-15 max-w-[160px]">
                              {this.renderTruncatedCell(
                                moment(value.created_at).format("D MMMM YYYY"),
                              )}
                            </td>
                          )}
                          {headers[11]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.event)}
                            </td>
                          )}
                          {headers[12]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.branch)}
                            </td>
                          )}
                          {headers[13]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(
                                value.active_status == 0
                                  ? "Deactivated"
                                  : "Activated",
                              )}
                            </td>
                          )}
                          {headers[14]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(value.referred_by)}
                            </td>
                          )}
                          {headers[15]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell("")}
                            </td>
                          )}
                          {headers[16]["checked"] && (
                            <td className="text-center max-w-[160px]">
                              {this.renderTruncatedCell(
                                this.getSignupDateDisplay(value),
                              )}
                            </td>
                          )}
                          {headers[17]["checked"] && (
                            <td className="w-[96px] min-w-[96px] bg-slate-50/40 text-center">
                              {this.renderRowActions(value)}
                            </td>
                          )}
                        </tr>
                      )))}
                    </tbody>
                  </table>
                </div>

                <div className="cms-list-card-view flex flex-col gap-3 bg-slate-50/50 p-3">
                  {this.renderMobileCards(
                    headers,
                    this.state.currentPage * this.state.perPage -
                      this.state.perPage +
                      1,
                  )}
                </div>

              </div>
            )}

            <div className="mt-4">
              <Paginations
                currentPage={this.state.currentPage}
                total={this.state.totalItem}
                itemsPerPage={this.state.perPage}
                lastPage={this.state.lastPage}
                totalItems={this.state.totalItem}
                perItem={this.state.perItem}
                onPageChange={this.handlePaginationCallback}
              />
            </div>

            <GenericMerge
              show={this.state.showMerge}
              title={"Merge Clients"}
              list={this.state.bulkIds}
              parentCallback={this.handleMergeModelCallback}
              merged_client={this.state.merged_client}
            />
            <ExternalAgentModel
              show={this.state.externalAgentModel}
              app={"clients"}
              bulkList={this.state.bulkIds}
              allAgents={this.state.allAgents}
              parentCallback={this.handleExternalAgentCallback}
            />
          </>
        ) : (
          <div className="rounded-xl border border-gray-200 bg-white p-6 text-center text-[13px] text-slate-500">
            You dont have permission to access this pages!
          </div>
        )}
      </div>
    );
  }
}
export default ViewClients;
